const validation = require('./validation');

export default {
   validation
}